import React, { useState, useEffect } from 'react';
const C = { grn:'#1D9E75', red:'#E24B4A', amber:'#BA7517', t2:'var(--t2)' };
const pc = v => v == null ? '\u2014' : (v > 0 ? '+' : '') + Number(v).toFixed(2) + '%';
const col = v => (v || 0) >= 0 ? C.grn : C.red;
const ST = { taken: C.grn, watching: C.amber, failed: C.red, 'too late': C.t2 };
const Th = ({children}) => <th style={{ textAlign:'left', fontSize:11, color:C.t2, fontWeight:500, padding:'6px 8px' }}>{children}</th>;
const Td = ({children, style}) => <td style={{ fontSize:12.5, padding:'6px 8px', borderTop:'1px solid var(--bd)', ...style }}>{children}</td>;
export default function IDWatch() {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    let live = true;
    const load = async () => { if (document.hidden) return;
      try { const r = await fetch('/intraday/watch'); if (r.ok) { const j = await r.json(); if (live) setRows(j.rows || []); } } catch (e) {} };
    load(); const id = setInterval(load, 15000); return () => { live = false; clearInterval(id); };
  }, []);
  return (<div style={{ background:'var(--bg1)', border:'1px solid var(--bd)', borderRadius:8, padding:16, margin:'14px 0' }}>
    <b style={{ fontSize:13 }}>Watch list</b> <span style={{ color:C.t2, fontSize:12 }}>each signal is taken only when it gains +0.1% for 3 minutes,
      with the market and sector agreeing and same-side signals working; checked every 15 s until 12:30.
      "First signal" shows what taking it blindly at the signal would have made.</span>
    <div style={{ overflowX:'auto' }}><table style={{ width:'100%', borderCollapse:'collapse', marginTop:8 }}>
      <thead><tr>{['signal','stock','side','gain now','best','status','why','taken','first signal','market','sector'].map(h => <Th key={h}>{h}</Th>)}</tr></thead>
      <tbody>{rows.map((r, i) => (<tr key={i}>
        <Td>{r.sig_time}</Td><Td style={{ fontWeight:600 }}>{r.symbol}</Td>
        <Td style={{ color:r.direction === 'LONG' ? C.grn : C.red, fontWeight:600 }}>{r.direction}</Td>
        <Td style={{ color:col(r.gain) }}>{pc(r.gain)}</Td><Td>{pc(r.best_gain)}</Td>
        <Td style={{ color:ST[r.status] || C.t2, fontWeight:600 }}>{r.status}</Td><Td style={{ color:C.t2 }}>{r.reason || ''}</Td>
        <Td>{r.taken_time ? `${r.taken_time} at ${r.taken_price}` : ''}</Td>
        <Td style={{ color:col(r.shadow_pct) }}>{r.shadow_pct != null ? `${pc(r.shadow_pct)} (${r.shadow_exit})` : ''}</Td>
        <Td style={{ color:C.t2 }}>{r.checks ? `${r.checks.mood || ''} ${pc(r.checks.market)}` : ''}</Td>
        <Td style={{ color:C.t2 }}>{r.checks && r.checks.sector ? `${r.checks.sector.replace('NIFTY ', '')} ${pc(r.checks.sector_chg)}` : ''}</Td>
      </tr>))}</tbody></table></div>
    {!rows.length && <div style={{ color:C.t2, fontSize:12, marginTop:8 }}>No signals watched yet today.</div>}
  </div>);
}
